module.exports = __webpack_public_path__ + "static/media/cross.1ebd8db3.svg";